module.exports = __webpack_public_path__ + "img/fwu.1e722993.png";